import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/constants";
import { useAuth, formatApiErrorDetail } from "@/AuthContext";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      setUser(data);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F7FB] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="CV Nur Rahma Logistics" className="h-16 mx-auto mb-4" />
          <h1 className="text-2xl font-black text-blue-950 tracking-tight" data-testid="login-title">Masuk Dashboard Admin</h1>
          <p className="text-sm text-slate-500 mt-1">Khusus pemilik & staf operasional Nurrahma Logistics</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white p-8 rounded-2xl border border-slate-200 shadow-md space-y-4" data-testid="login-form">
          {error && (
            <div className="p-3 rounded-lg bg-red-50 border border-red-200 text-red-700 text-xs font-medium" data-testid="login-error">
              {error}
            </div>
          )}
          <div>
            <label htmlFor="email" className="block text-xs font-semibold text-slate-700 mb-1">Email</label>
            <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3.5 py-2.5 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-900"
              placeholder="email@nurrahmalogistics.id" data-testid="login-email" />
          </div>
          <div>
            <label htmlFor="password" className="block text-xs font-semibold text-slate-700 mb-1">Kata Sandi</label>
            <input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3.5 py-2.5 rounded-lg border border-slate-300 text-sm focus:outline-none focus:ring-2 focus:ring-blue-900"
              placeholder="••••••••" data-testid="login-password" />
          </div>
          <button type="submit" disabled={loading}
            className="w-full py-3.5 rounded-xl bg-blue-900 text-amber-300 font-bold text-sm hover:bg-blue-950 transition-colors shadow-md disabled:opacity-60"
            data-testid="login-form-submit-button">
            {loading ? "Memeriksa..." : "Masuk"}
          </button>
        </form>

        <p className="text-center mt-6">
          <Link to="/" className="text-xs text-slate-500 hover:text-blue-900 transition-colors" data-testid="back-to-home">← Kembali ke Beranda</Link>
        </p>
      </div>
    </div>
  );
}
